import { createContext } from "react";
var OnColorContext = /*#__PURE__*/createContext("backgroundLight");
export default OnColorContext;